$('html').removeClass('no-js');

$(function () {
    /* global Modernizr:true */

    var _this = this,
        _body = $('body');

    // $(document).pjax('a', {
    //     container: '#pjax-container',
    //     fragment: '#pjax-container',
    //     timeout: 5000,
    //     cacheBeforeEval: true,
    //     maxCacheLength: 0
    // });

    /*
        INIT
    */
    _this.initPJAX = function() {

        $.pjax.defaults.timeout = 5000;

        if ($.support.pjax) {
            $('a[href$=".pdf"]').addClass('external');

            $(document).pjax('a:not(.external):not(.bugfix-anchor):not([href="#"]):not([rel="external"])', {
                container: '#pjax-container',
                fragment: '#pjax-container',
                cacheBeforeEval: true,
                maxCacheLength: 0
            });

            $(document).on('pjax:start', function() {
                // console.log('pjax:start');
            });

            $(document).on('pjax:beforeReplace', function() {
                // console.log('pjax:beforeReplace');
            });

            $(document).on('pjax:end', function() {
                // console.log('pjax:end');

                // everytime pjax request ends, execute the init again.
                _this.init();
            });

            $(document).on('pjax:success', function() {
                // console.log('pjax:success');
            });

            $(document).on('pjax:complete', function(event, request) {
                // console.log('pjax:complete');
            });

            $(document).on('pjax:error', function(e, xhr, err) {
                console.log('Something went wrong: ' + err);
            });
        } else {

        }

    }; // end of init

    /**
     * Here goes all code for initialisation of page.
     */
    _this.init = function()
    {
        // handle the mouseenter functionality
        $(".featured").mouseenter(function(){
            $(this).find('.img').addClass("hover");
        })
        // handle the mouseleave functionality
        .mouseleave(function(){
            $(this).find('.img').removeClass("hover");
        });


        // Initialize
        $('.parallax-mirror').remove();
        var imageSrc = $('#omslag').data('parallax-source');

        $('#omslag').parallax({
            imageSrc: imageSrc,
            positionY: 'center',
            zIndex: '1'
        });

        // Initializes navigation plugin
        // -- /js/navigation.plugin.js
        $('#navigation').navigationPlugin({
            subnavSpeed: 200,
            subnavCloseDelay: 500,
            subnavCloseOnHover: true,
            alternateLogoPath: '/img/logo-witteveen-bv.png'
        });

        $('select:not(.noNiceSelect)').niceSelect();
        $('body').customerPlugin();

        if ($('[type="date"]').prop('type') != 'date') {
            $('[type="date"]').datepicker({
                dateFormat: 'dd-mm-yy'
            });
        }


        // Initializes slimscroll plugin
        // -- /js/vendor/jquery.plugin.package.min.js
        // $('.slim-scroll').slimscroll({
        //     height: '100%',
        //     width: '100%',
        //     railVisible: true,
        //     railColor: '#00aeef',
        //     color: '#00aeef'
        // });

        // *************************
        // **  CUSTOM JAVASCRIPT  **
        // *************************

        // Example:
        // <a href="#" title="" class="rel-external">link</a>
        $('.rel-external, .external').on('click', function(e) {
            e.preventDefault();
            var url = $(this).attr('href');
            window.open(url, '_blank');
        });

        if ($('#chatbox').length > 0)
            $('#chatbox').chat();

        $(".clickable-row td").click(function() {
            if($(this).hasClass('select_driver'))
            {
                _this.SelectDriver();
            }
            else
            {
                window.location = $(this).parent('tr').data("href");
            }
        });

        /*
        * MULTI SELECT CARS AND ADD DRIVERS
        * */
        // $(document).on('click', 'input[type="selectbox"].select_driver', function () {
        //     $(this).each(function(){
        //        console.log('test');
        //     });
        // });

    };

    _this.SelectDriver = function () {
        var checked = false;
        var first   = true;
        var car_chassis = '';
        var car_ids = '';

        $('input.select_driver_check').each(function () {
            if($(this).is(":checked"))
            {
                checked = true;

                if(first === true)
                {
                    first = false;
                    car_ids = car_ids + $(this).data('id');
                }
                else
                {
                    car_ids = car_ids + ',' + $(this).data('id');
                }

                car_chassis = car_chassis + '<li>' + $(this).data('chassis') + '</li>';
            }
        });

        if(checked === true)
        {
            if(car_ids)
            {
                $('input[name="car_ids"]').val(car_ids);
            }

            if(car_chassis)
            {
                $('ul#select_driver_chassis').html(car_chassis);
            }
        }
        else
        {
            $('input[name="car_ids"]').val('');
            $('ul#select_driver_chassis').html('');
        }
    };

    /**
     *  If body is loaded already, do not re-init pjax.
     */
    if (!_body.hasClass('loaded'))
    {
        // _this.initPJAX();
        _this.init();
    }
});